(function (angular) {
  "use strict";

  angular.module("Toyota.Factories").factory("Location", [
    "$rootScope",
    "localstorage",
    "cookies",
    function ($rootScope, localstorage, cookies) {
      var LOCAL_STORAGE_KEY = "location_service_information";
      var PREV_SAVED_LOCAL_STORAGE_KEY = "prev_location_service_information";
      var LOCAL_STORAGE_HAS_SHOWN_INVALID_COUNTRY_TOAST_KEY = "location_service_has_shown_invalid_country_toast";

      /*
       * internal state
       * this is used to handle not having localstorage working
       * if something else writes to this localstorage location, we don't support picking that up until a page reload
       */

      var emptyLocationObject = {
        postcode: "",
        suburb: "",
        state: "",
        region: "",
        pricingZone: "",
        source: "",
      };

      var prevSavedLocationObject = angular.copy(emptyLocationObject);
      var locationObject = angular.copy(emptyLocationObject);

      function updatePrevSavedLocation() {
        prevSavedLocationObject = angular.copy(locationObject);

        localstorage.set(PREV_SAVED_LOCAL_STORAGE_KEY, prevSavedLocationObject);
      }

      function revertToPrevSavedLocation() {
        var prevSaved = getPrevSavedLocation();
        update(
          prevSaved.postcode,
          prevSaved.suburb,
          prevSaved.state,
          prevSaved.region,
          prevSaved.pricingZone,
          prevSaved.source
        );

        prevSavedLocationObject = angular.copy(emptyLocationObject);
        localstorage.set(PREV_SAVED_LOCAL_STORAGE_KEY, emptyLocationObject);
      }

      function update(postcode, suburb, state, region, pricingZone, source) {
        locationObject.postcode = postcode;
        locationObject.suburb = suburb;
        locationObject.state = state;
        locationObject.region = region;
        locationObject.pricingZone = pricingZone;
        locationObject.source = source;

        //Property `source` should not be saved in local storage
        localstorage.set(LOCAL_STORAGE_KEY, {
          postcode: postcode,
          suburb: suburb,
          state: state,
          region: region,
          pricingZone: pricingZone,
        });

        triggerChange();
      }

      // get data out of local storage
      function retrieve(localStorageKey) {
        if (!localstorage.exists(localStorageKey)) {
          return angular.copy(emptyLocationObject);
        }

        const currentLocalStorage = localstorage.get(localStorageKey);
        if (currentLocalStorage?.pricingZone) {
          currentLocalStorage.source = "local-storage";
          return currentLocalStorage;
        }

        localstorage.remove(localStorageKey);
        return angular.copy(emptyLocationObject);
      }

      function get() {
        // internal state takes precedence, if it's there
        if (locationObject.postcode !== "") {
          return locationObject;
        }

        // get the data from localstorage
        locationObject = retrieve(LOCAL_STORAGE_KEY);

        // remove the localstorage expiry date
        delete locationObject.expiry;

        return locationObject;
      }

      function remove() {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
        localStorage.removeItem(PREV_SAVED_LOCAL_STORAGE_KEY);
      }

      function getPrevSavedLocation() {
        if (prevSavedLocationObject.postcode !== "") {
          return prevSavedLocationObject;
        }

        prevSavedLocationObject = retrieve(PREV_SAVED_LOCAL_STORAGE_KEY);

        delete prevSavedLocationObject.expiry;

        return prevSavedLocationObject;
      }

      function getHasShownInvalidCountryToast() {
        if (localstorage.exists(LOCAL_STORAGE_HAS_SHOWN_INVALID_COUNTRY_TOAST_KEY)) {
          return localstorage.get(LOCAL_STORAGE_HAS_SHOWN_INVALID_COUNTRY_TOAST_KEY).val === "true";
        }

        return false;
      }

      function setHasShownInvalidCountryToast(hasShownInvalidCountryToast) {
        localstorage.set(
          LOCAL_STORAGE_HAS_SHOWN_INVALID_COUNTRY_TOAST_KEY,
          hasShownInvalidCountryToast ? "true" : "false"
        );
      }

      function triggerChange() {
        $rootScope.$broadcast(
          "GeoPostCode",
          locationObject.postcode,
          locationObject.suburb,
          locationObject.state,
          locationObject.region,
          locationObject.pricingZone,
          locationObject.source
        );
      }

      // set the internal state based on the localstorage, if there's anything
      locationObject.postcode = get().postcode;
      locationObject.suburb = get().suburb;
      locationObject.state = get().state;
      locationObject.region = get().region;
      locationObject.pricingZone = get().pricingZone;
      locationObject.source = get().source;

      return {
        update: update,
        updatePrevSavedLocation: updatePrevSavedLocation,
        get: get,
        remove: remove,
        revertToPrevSaved: revertToPrevSavedLocation,
        getHasShownInvalidCountryToast: getHasShownInvalidCountryToast,
        setHasShownInvalidCountryToast: setHasShownInvalidCountryToast,
      };
    },
  ]);
})(window.angular);
